import ContactLensImageTypeSwitcherFloat from '@/components/organisms/item-list/ContactLensImageTypeSwitcherFloat.vue'
import { ItemKind } from '@/models/item/kind'
import Vue from 'vue'

/**
 * itemKind に応じた商品一覧ヘッダー追加コンポーネントを返すビルダー
 * （ list-header スロットに差し込まれるコンポーネント全般を指す）
 * 現状 ContactLensImageTypeSwitcherFloat 専用
 */
export default class ItemListHeaderAddonBuilder {
  static create(
    itemKind: ItemKind,
    displayLevelOfImageToDisplay: number | null
  ): ItemListHeaderAddonBuilder {
    return new ItemListHeaderAddonBuilder(itemKind, displayLevelOfImageToDisplay)
  }

  private constructor(
    private itemKind: ItemKind,
    private displayLevelOfImageToDisplay: number | null
  ) {}

  // 追加コンポーネントを返す。表示しない場合は null を返す
  // displayLevelOfImageToDisplay が指定されている場合は外部指定が優先されるため非表示
  build(): typeof Vue | null {
    if (this.itemKind === 'contact-lens' && this.displayLevelOfImageToDisplay === null) {
      return ContactLensImageTypeSwitcherFloat
    }

    return null
  }
}
